<template>
  <div class="skill-section">
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <div class="col-lg-6 col-xl-7">
          <div class="skill-image">
            <div class="row position-relative">
              <img
                src="@/assets/img/bg/book-bg.png"
                alt="img"
                class="img-fluid img-04 d-none d-xl-flex"
              />
              <img
                src="@/assets/img/icons/icon-31.png"
                alt="img"
                class="img-fluid img-05 d-none d-xl-flex"
              />
              <div class="col-md-6 d-flex">
                <div class="flex-fill">
                  <img
                    src="@/assets/img/feature/feature-27.jpg"
                    alt="img"
                    class="img-fluid flex-fill img-01 aos"
                    data-aos="fade-right"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <img
                    src="@/assets/img/feature/feature-26.jpg"
                    alt="img"
                    class="img-fluid img-02 aos"
                    data-aos="fade-down"
                  />
                </div>
                <div>
                  <img
                    src="@/assets/img/feature/feature-28.jpg"
                    alt="img"
                    class="img-fluid img-03 aos"
                    data-aos="fade-up"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xl-5 aos" data-aos="fade-up">
          <div class="skill-content">
            <h2>Master the Skills To Drive Your Career</h2>
            <p>
              Get certified, master modern tech skills, and level up your career whether
              you’re starting out or a seasoned pro. 95% of eLearning learners report our
              hands-on content directly helped their careers.
            </p>
            <div class="skill-list mb-4">
              <p class="d-flex align-items-center">
                <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Access Your
                Class anywhere
              </p>
              <p class="d-flex align-items-center">
                <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Flexible
                Course Plan
              </p>
              <p class="d-flex align-items-center">
                <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Quality
                Assurance
              </p>
              <p class="d-flex align-items-center">
                <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i
                >Cost-Effectiveness
              </p>
              <p class="d-flex align-items-center">
                <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>The Most
                World Class Instructors
              </p>
              <p class="d-flex align-items-center">
                <i class="isax isax-tick-circle5 text-success fs-24 me-2"></i>Quality
                Assurance
              </p>
            </div>
            <router-link
              to="/course/course-list"
              class="btn btn-dark btn-xl rounded-pill d-inline-flex align-items-center"
              >Get Started<i class="isax isax-arrow-right-3 ms-2"></i
            ></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
